import React, { useEffect } from "react"
import { connect, ConnectedProps } from "react-redux"
import { useHistory } from "react-router-dom"
import { logout, toggleSideNav } from "src/App/App.actions"
import { MyIcon, MyModal } from "src/core/components"
import { HAuth } from "src/core/helpers"
import { getHomepageUrl } from "src/core/helpers/auth"
import { PATH } from "src/helpers/paths"
import { HCF } from "@macashipo/mlib"
import {
  Path,
  ConfigPageScreen,
  ScreenCode,
} from "src/modules/app_dnt/constants/path"
import { Button } from "reactstrap"
import { useTranslation } from "react-i18next"
import { LogoApp } from "./Header.styles"
import Avatar from "./Avatar"
import Notify from "./Notify"
import HeaderTitle from "./HeaderTitle"

const mapStateToProps = state => ({
  closeSideNav: state.app.closeSideNav,
  headerTitle: state.app.headerTitle,
})

const mapDispatchToProps = {
  logout,
  toggleSideNav,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

interface Props extends ConnectedProps<typeof connector> {
  menuShow?: any
}

const Header = (props: Props) => {
  const { logout, closeSideNav, headerTitle, menuShow, toggleSideNav } = props
  const { t } = useTranslation()
  // const { currentHeaderTitle } = useShareableState()
  const history = useHistory()
  const handleLogout = () => {
    logout()
    history.push(Path.LOGIN)
  }
  const getLogoApp = () => {
    const useLogoServer = HCF.getCF("useLogoServer")
    const defaultLogo = HCF.getCF("pathMainLogo")
    const userLogoApp = HAuth.getUserLogoApp()
    if (useLogoServer) {
      if (userLogoApp) {
        return userLogoApp
      }
    }
    return defaultLogo
  }
  const getIsShowCreateTaskBtn = () => {
    if (closeSideNav && window.location.pathname !== Path.CREATE_TASK) {
      if (menuShow && menuShow.includes(ScreenCode.CREATE_TASK)) {
        return true
      }
    }
    return false
  }
  useEffect(() => {}, [history])
  return (
    <header className="c-header d-flex bg-white align-items-center justify-content-between p-2 shadow-sm">
      <button
        className={`c-menu btn btn-primary-white no-print header-desktop`}
        onClick={toggleSideNav}
      >
        <MyIcon data="type:HiMenu" size={16} />
      </button>
      <div className="header-center" style={{ minWidth: "40px" }}>
        {closeSideNav && (
          <LogoApp className="logo-app me-3">
            <a
              href="#"
              onClick={e => {
                e.preventDefault()
                const url = getHomepageUrl()
                history.push(url === PATH.HOME ? PATH.MY_PROFILE : url)
              }}
            >
              <img src={getLogoApp()} alt={HCF.getCF("appName")} />
            </a>
          </LogoApp>
        )}
        <HeaderTitle />
        {getIsShowCreateTaskBtn() && (
          <Button
            color="primary"
            className="create-task no-print"
            onClick={() => {
              MyModal.showFromMyPage(
                {
                  ...ConfigPageScreen[ScreenCode.CREATE_TASK],
                  Title: headerTitle, // Keep current title
                  MoreProps: {
                    isInPopup: true,
                  },
                },
                {
                  title: "Create New Task",
                  dragable: true,
                  size: "xl no-scroll modal-bs-background",
                }
              )
            }}
          >
            {t(`dnt:header.Create Task`)}
          </Button>
        )}
      </div>
      <ul className="navbar-nav navbar-nav-icons ml-auto d-flex flex-row align-items-center mb-0 header-desktop">
        <li className="nav-item">
          <Notify />
        </li>
        <li className="nav-item">
          <Avatar handleLogout={handleLogout} />
        </li>
      </ul>
      <div className="header-mobile">
        <div className="header-mobile-top d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <button
              className={`c-menu btn btn-primary-white no-print`}
              onClick={toggleSideNav}
            >
              <MyIcon data="type:HiMenu" size={16} />
            </button>
            <LogoApp className="logo-app me-3">
              <a href="/">
                <img src={getLogoApp()} alt={HCF.getCF("appName")} />
              </a>
            </LogoApp>
          </div>
          <ul className="navbar-nav navbar-nav-icons ml-auto d-flex flex-row align-items-center mb-0">
            <li className="nav-item">
              <Notify />
            </li>
            <li className="nav-item">
              <Avatar handleLogout={handleLogout} />
            </li>
          </ul>
        </div>
        <div className="header-center" style={{ minWidth: "40px" }}>
          <HeaderTitle />
          <Button
            color="primary"
            className="create-task no-print"
            onClick={() => {
              MyModal.showFromMyPage(
                {
                  ...ConfigPageScreen[ScreenCode.CREATE_TASK],
                  Title: headerTitle, // Keep current title
                  MoreProps: {
                    isInPopup: true,
                  },
                },
                {
                  title: "Create New Task",
                  dragable: true,
                  size: "xl no-scroll modal-bs-background",
                }
              )
            }}
          >
            {t(`dnt:header.Create Task`)}
          </Button>
        </div>
      </div>
    </header>
  )
}

export default connector(Header)
